module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7098/images/default-company-avatar.png"